(function () {
  window.initYgProductGalleryV2 = (scope = document) => {
    const container = scope instanceof Element
      ? scope.querySelector('.yg-gallery-container')
      : document.querySelector('.yg-gallery-container');

    if (!container || container.dataset.ygGalleryV2Initialized === 'true') return;

    container.dataset.ygGalleryV2Initialized = 'true';
    const abortController = new AbortController();
    const { signal } = abortController;
    container.ygGalleryV2Cleanup = () => abortController.abort();

    const carousel = container.querySelector('.yg-carousel');
    const slides = Array.from(container.querySelectorAll('.yg-slide'));
    const thumbBtns = container.querySelectorAll('.yg-thumb-btn');
    const btnPrev = container.querySelector('.yg-arrow.prev');
    const btnNext = container.querySelector('.yg-arrow.next');

    const productFormId = container.dataset.productFormId || '';
    const form = container.closest('product-rerender')?.querySelector('form[action*="/cart/add"]') || document.querySelector('form#' + productFormId);
    const variantMapEl = container.querySelector('.yg-variant-map');
    const variantMap = variantMapEl ? JSON.parse(variantMapEl.textContent) : {};
    const mediaGroupMapEl = container.querySelector('.yg-media-group-map');
    let mediaGroupMap = {};

    try {
      const parsedMediaGroupMap = JSON.parse(mediaGroupMapEl?.textContent || '{}');
      if (parsedMediaGroupMap && typeof parsedMediaGroupMap === 'object' && !Array.isArray(parsedMediaGroupMap)) {
        mediaGroupMap = parsedMediaGroupMap;
      }
    } catch (error) {
      console.warn('Unable to read product variant media groups.', error);
    }

    slides.forEach(slide => {
      const mediaId = String(slide.dataset.mediaId || '');
      const mappedCodes = mediaGroupMap[mediaId];

      if (typeof mappedCodes === 'string') {
        slide.dataset.variantCodes = mappedCodes.toLowerCase();
      }
    });

    let currentTab = container.dataset.initialTab || 'image';
    let eventVariantId = '';

    const uniqueTags = (tags) => Array.from(new Set(tags.filter(Boolean)));

    const extractNumberKeys = (str) => {
      const value = (str || '').toLowerCase();
      const numbers = value.match(/\d{6,}/g) || [];
      return uniqueTags(numbers.map(number => `#${number}`));
    };

    const normalizeVariantId = (value) => {
      const id = String(value || '').trim();
      return variantMap[id] ? id : '';
    };

    const getVariantIdFromUrl = () => {
      try {
        return normalizeVariantId(new URL(window.location.href).searchParams.get('variant'));
      } catch (error) {
        return '';
      }
    };

    const getVariantIdFromInputs = () => {
      const inputs = Array.from(document.querySelectorAll('form[action*="/cart/add"] [name="id"], form [name="id"], input[name="id"]'));
      const scopedInput = form ? form.querySelector('[name="id"]') : null;
      const candidates = scopedInput ? [scopedInput, ...inputs.filter(input => input !== scopedInput)] : inputs;

      for (const input of candidates) {
        const id = normalizeVariantId(input.value);
        if (id) return id;
      }

      return '';
    };

    const getActiveVariantId = () => {
      return getVariantIdFromUrl() || normalizeVariantId(eventVariantId) || getVariantIdFromInputs();
    };

    const renderGallery = () => {
      let activeCodeTags = [];
      const activeVariantId = getActiveVariantId();

      if (activeVariantId && variantMap[activeVariantId]) {
        const activeVariant = variantMap[activeVariantId];
        activeCodeTags = uniqueTags((activeVariant.codes || []).flatMap(extractNumberKeys));
      }

      const activeVariantMediaId = activeVariantId && variantMap[activeVariantId]?.media_id
        ? String(variantMap[activeVariantId].media_id)
        : '';

      let visibleCount = 0;
      let firstVisibleSlide = null;

      slides.forEach(slide => {
        const type = slide.dataset.logicalType;
        const rawVariantCodes = (slide.dataset.variantCodes || '').trim().toLowerCase();
        const codesHaveHash = rawVariantCodes.includes('#');
        const variantCodeTags = codesHaveHash ? extractNumberKeys(rawVariantCodes) : [];
        const codeMatch = activeCodeTags.some(tag => variantCodeTags.includes(tag));
        const mediaIdMatch = activeVariantMediaId && String(slide.dataset.mediaId || '') === activeVariantMediaId;
        const isCommonImage = rawVariantCodes === '' || rawVariantCodes.includes('#common') || !codesHaveHash;

        let isShow = false;

        if (type === currentTab) {
          if (type === 'image') {
            if (mediaIdMatch || codeMatch || isCommonImage) {
              isShow = true;
            }
          } else {
            isShow = true;
          }
        }

        if (isShow) {
          slide.classList.remove('yg-hidden');
          visibleCount++;
          if (!firstVisibleSlide) firstVisibleSlide = slide;
        } else {
          slide.classList.add('yg-hidden');
        }
      });

      if (visibleCount <= 1) {
        btnPrev.classList.add('yg-hidden');
        btnNext.classList.add('yg-hidden');
        carousel.style.overflowX = 'hidden';
      } else {
        btnPrev.classList.remove('yg-hidden');
        btnNext.classList.remove('yg-hidden');
        carousel.style.overflowX = 'auto';
      }

      if (firstVisibleSlide) {
        carousel.scrollTo({ left: firstVisibleSlide.offsetLeft, behavior: 'auto' });
        updateDynamicThumb(firstVisibleSlide);
      }
    };

    const updateDynamicThumb = (slide) => {
      const type = slide.dataset.logicalType;
      if (type === 'image' || type === 'render_metafield') {
        const thumbImg = container.querySelector(type === 'image' ? '.yg-dynamic-thumb-image' : '.yg-dynamic-thumb-render');
        const slideImg = slide.querySelector('img');
        if (thumbImg && slideImg) {
          thumbImg.src = slideImg.src;
        }
      }
    };

    thumbBtns.forEach(b => b.classList.toggle('is-active', b.dataset.target === currentTab));
    renderGallery();

    thumbBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        currentTab = btn.dataset.target;
        thumbBtns.forEach(b => b.classList.toggle('is-active', b.dataset.target === currentTab));
        renderGallery();
      }, { signal });
    });

    btnPrev.addEventListener('click', () => {
      const visibleSlides = slides.filter(s => !s.classList.contains('yg-hidden'));
      if (visibleSlides.length <= 1) return;

      const center = carousel.scrollLeft + carousel.clientWidth / 2;
      let currentIndex = 0;
      let minDist = Infinity;
      visibleSlides.forEach((s, idx) => {
        const dist = Math.abs(s.offsetLeft + s.clientWidth / 2 - center);
        if (dist < minDist) { minDist = dist; currentIndex = idx; }
      });

      const target = visibleSlides[currentIndex - 1] || visibleSlides[visibleSlides.length - 1];
      carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }, { signal });

    btnNext.addEventListener('click', () => {
      const visibleSlides = slides.filter(s => !s.classList.contains('yg-hidden'));
      if (visibleSlides.length <= 1) return;

      const center = carousel.scrollLeft + carousel.clientWidth / 2;
      let currentIndex = 0;
      let minDist = Infinity;
      visibleSlides.forEach((s, idx) => {
        const dist = Math.abs(s.offsetLeft + s.clientWidth / 2 - center);
        if (dist < minDist) { minDist = dist; currentIndex = idx; }
      });

      const target = visibleSlides[currentIndex + 1] || visibleSlides[0];
      carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }, { signal });

    carousel.addEventListener('scroll', () => {
      const visibleSlides = slides.filter(s => !s.classList.contains('yg-hidden'));
      if (visibleSlides.length === 0) return;
      const center = carousel.scrollLeft + carousel.clientWidth / 2;
      let closestSlide = visibleSlides[0];
      let minDist = Infinity;
      visibleSlides.forEach(s => {
        const dist = Math.abs(s.offsetLeft + s.clientWidth / 2 - center);
        if (dist < minDist) { minDist = dist; closestSlide = s; }
      });
      updateDynamicThumb(closestSlide);
    }, { signal });

    let lastVariantId = getActiveVariantId();

    const syncVariantGallery = () => {
      const nextVariantId = getActiveVariantId();
      if (!nextVariantId || nextVariantId === lastVariantId) return;

      lastVariantId = nextVariantId;
      renderGallery();
    };

    const scheduleSyncVariantGallery = (delay = 0) => {
      window.setTimeout(syncVariantGallery, delay);
    };

    if (!window.ygVariantUrlSyncReady) {
      window.ygVariantUrlSyncReady = true;

      ['pushState', 'replaceState'].forEach(methodName => {
        const originalMethod = window.history[methodName];

        window.history[methodName] = function () {
          const result = originalMethod.apply(this, arguments);
          window.dispatchEvent(new Event('yg:variant-url-change'));
          return result;
        };
      });

      window.addEventListener('popstate', () => {
        window.dispatchEvent(new Event('yg:variant-url-change'));
      });
    }

    ['variant:change', 'product:variant-change', 'variant-change'].forEach(eventName => {
      document.addEventListener(eventName, event => {
        const variant = event.detail?.variant || event.detail;
        if (variant?.id) {
          eventVariantId = String(variant.id);
        }

        scheduleSyncVariantGallery();
      }, { signal });
    });

    document.addEventListener('change', event => {
      const target = event.target;

      if (target?.closest?.('form') || target?.closest?.('variant-picker, .variant-picker, .product-info__variant-picker')) {
        scheduleSyncVariantGallery(50);
      }
    }, { capture: true, signal });

    document.addEventListener('click', event => {
      const target = event.target;

      if (target?.closest?.('variant-picker, .variant-picker, .product-info__variant-picker')) {
        scheduleSyncVariantGallery(80);
        scheduleSyncVariantGallery(180);
      }
    }, { capture: true, signal });

    window.addEventListener('yg:variant-url-change', () => {
      scheduleSyncVariantGallery();
    }, { signal });
  };

  window.destroyYgProductGalleryV2 = (scope = document) => {
    const container = scope instanceof Element
      ? scope.querySelector('.yg-gallery-container')
      : document.querySelector('.yg-gallery-container');

    container?.ygGalleryV2Cleanup?.();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.initYgProductGalleryV2(), { once: true });
  } else {
    window.initYgProductGalleryV2();
  }
})();
